import React from 'react'
import { cx } from 'class-variance-authority'

const DOT_PATTERN_SVG = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="6" cy="6" r="2" fill="white" fill-opacity="0.5" /></svg>`

const BrowserDots = () => (
  <svg width="39" height="8" viewBox="0 0 39 8" fill="none">
    <circle cx="4" cy="4" r="3.5" fill="#FF5F57" stroke="#E0443E" />
    <circle cx="20" cy="4" r="3.5" fill="#FFBD2E" stroke="#DEA123" />
    <circle cx="35" cy="4" r="3.5" fill="#28CA42" stroke="#1AAB29" />
  </svg>
)

interface BuilderBackgroundProps {
  className?: string
  children?: React.ReactNode
  actions?: React.ReactNode
  iframeMode?: boolean
}

export const BuilderBackground: React.FC<BuilderBackgroundProps> = ({
  className = '',
  children,
  actions,
  iframeMode = false,
}) => {
  const createDotPattern = () => {
    return `data:image/svg+xml;base64,${btoa(DOT_PATTERN_SVG)}`
  }

  return (
    <div
      id="builder-background"
      className={cx(
        'bg-silver-100 rounded-[20px] p-md flex flex-col items-center',
        !iframeMode && 'min-h-[600px]',
        actions && 'gap-4xl',
        className,
      )}
      style={{
        backgroundImage: `url("${createDotPattern()}")`,
        backgroundRepeat: 'repeat',
        backgroundSize: '16px 16px',
      }}
    >
      {actions}

      <div
        id="browser-mockup"
        className={cx(
          'w-full flex-1 border border-field-border overflow-hidden flex flex-col',
          iframeMode ? 'rounded-t-2xl rounded-b-xs' : 'rounded-2xl',
        )}
      >
        <div className="flex items-center p-md bg-white">
          <div className="flex items-center gap-4 w-full">
            <BrowserDots />
            <div className="flex-1 h-2 bg-field-border rounded-full" />
          </div>
        </div>

        <div
          id="browser-content"
          className={cx(
            'flex-1 flex flex-col [container-type:inline-size]',
            !iframeMode && 'p-md',
          )}
        >
          {children}
        </div>
      </div>
    </div>
  )
}

export default BuilderBackground
